/**
 * Enum for search results view type
 */
export enum SearchTypeView {
  ListView = 'ListView',
  MapView = 'MapView',
}

/**
 * Enum for agent/agency type filter
 */
export enum SearchAgentType {
  SalesAgent = 'Sales Agent',
  PropertyManager = 'Property Manager',
}
